import { Injectable } from '@angular/core';
import { ResponseStructure, ResponseCode } from '@iq-central-front-end/share';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class GlobalService {
  constructor(
    private _spinner: NgxSpinnerService,
    private _toastr: ToastrService
  ) {}
  showSpinner() {
    this._spinner.show();
  }

  hideSpinner() {
    this._spinner.hide();
  }

  hideSpinnerWithMessage(response, icon) {
    this._spinner.hide();
    Swal.fire({
      icon: icon,
      title: response.responseResult,
      showConfirmButton: false,
      timer: 3000
    });
  }

  globalAuthErrorHandler(error: ResponseStructure) {
    this.hideSpinner();
    if (error) {
      switch (error.responseCode) {
        case ResponseCode.UNAUTHORIZED:
          this._toastr.warning(
            error.responseResult,
            'Hey I know you but you dont have the permission to do this'
          );
          break;
        case ResponseCode.FORBIDDEN:
          this._toastr.warning(error.responseResult, 'Incorrect Credentials');
          break;
        case ResponseCode.NOT_FOUND:
          this._toastr.warning(error.responseResult, 'Not found');
          break;
        case ResponseCode.BAD_REQUEST:
          this._toastr.warning(error.responseResult, 'Bad Request');
          break;
        default:
          break;
      }
    }
  }

  globalSuccessHandler(rez: ResponseStructure) {
    this.hideSpinner();
    this._toastr.success(rez.responseResult, 'Successful');
  }
  success() {
    this.hideSpinner();
    this._toastr.success('Successful');
  }
  successHandlerWithObject(rez) {
    this.hideSpinner();
    this._toastr.success(rez.responseMessage);
  }

  handleUnauthenticated() {
    this._toastr.error('You have to be logged in', 'Incorrect Credentials');
  }

  handleNetworkError() {
    this._spinner.hide();
    Swal.fire({
      icon: 'error',
      title: 'Oops...',
      text: 'Please ensure that you are connected to the internet!',
      timer: 5000
    });
  }
}
